module.exports = __webpack_public_path__ + "static/media/toelogic-3.16f493db.jpg";